 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-ar":"lang-ar","lang-de":"lang-de","lang-en":"lang-en","lang-es":"lang-es","lang-fr":"lang-fr","lang-he":"lang-he","lang-hi":"lang-hi","lang-it":"lang-it","lang-ja":"lang-ja","lang-ko":"lang-ko","lang-pl":"lang-pl","lang-pt":"lang-pt","lang-ru":"lang-ru","lang-tr":"lang-tr","lang-uk":"lang-uk","lang-vi":"lang-vi","lang-zh-cn":"lang-zh-cn","lang-zh-tw":"lang-zh-tw"}[chunkId]||chunkId) + "." + {"chunk-0eb601c5":"d49a29b1","chunk-101815f6":"2713003c","chunk-742b4af6":"bc33059d","chunk-7b5630b7":"7b6b770c","chunk-36a0e991":"76c54419","chunk-c0ace5ba":"85fa919f","chunk-1053d8b3":"be0614c5","chunk-25847fd8":"49f9b55c","chunk-3b83dda3":"45488abf","chunk-43a4e444":"ff300555","chunk-5087da3a":"378c9425","chunk-53719846":"5c424f79","chunk-7a62f7ab":"21ceccd6","chunk-ac9b3dd0":"4f46ad19","chunk-ad60b848":"f5374250","chunk-fd2fbc56":"c5813038","lang-ar":"9a2d334e","lang-de":"dba51aae","lang-en":"f6bb459a","lang-es":"bc51374f","lang-fr":"437f7ee7","lang-he":"343319d4","lang-hi":"5d2d2af2","lang-it":"41bb494d","lang-ja":"0d5bc276","lang-ko":"1b59950c","lang-pl":"83ae14d7","lang-pt":"0b80b88f","lang-ru":"e49fd5ed","lang-tr":"72ad6139","lang-uk":"99a6be06","lang-vi":"d3200b97","lang-zh-cn":"15079e55","lang-zh-tw":"2d0ec83b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0eb601c5":1,"chunk-742b4af6":1,"chunk-7b5630b7":1,"chunk-36a0e991":1,"chunk-c0ace5ba":1,"chunk-1053d8b3":1,"chunk-25847fd8":1,"chunk-3b83dda3":1,"chunk-43a4e444":1,"chunk-5087da3a":1,"chunk-53719846":1,"chunk-7a62f7ab":1,"chunk-ac9b3dd0":1,"chunk-ad60b848":1,"chunk-fd2fbc56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-ar":"lang-ar","lang-de":"lang-de","lang-en":"lang-en","lang-es":"lang-es","lang-fr":"lang-fr","lang-he":"lang-he","lang-hi":"lang-hi","lang-it":"lang-it","lang-ja":"lang-ja","lang-ko":"lang-ko","lang-pl":"lang-pl","lang-pt":"lang-pt","lang-ru":"lang-ru","lang-tr":"lang-tr","lang-uk":"lang-uk","lang-vi":"lang-vi","lang-zh-cn":"lang-zh-cn","lang-zh-tw":"lang-zh-tw"}[chunkId]||chunkId) + "." + {"chunk-0eb601c5":"bdb230f0","chunk-101815f6":"31d6cfe0","chunk-742b4af6":"cad92cc8","chunk-7b5630b7":"095c3dbd","chunk-36a0e991":"ac3f41e8","chunk-c0ace5ba":"d5c5b70d","chunk-1053d8b3":"db1a9a76","chunk-25847fd8":"99fdeb8e","chunk-3b83dda3":"c03aefdb","chunk-43a4e444":"7129d25d","chunk-5087da3a":"f55c2a27","chunk-53719846":"c03aefdb","chunk-7a62f7ab":"cb45d5ed","chunk-ac9b3dd0":"c03aefdb","chunk-ad60b848":"8f2edece","chunk-fd2fbc56":"0b8104d7","lang-ar":"31d6cfe0","lang-de":"31d6cfe0","lang-en":"31d6cfe0","lang-es":"31d6cfe0","lang-fr":"31d6cfe0","lang-he":"31d6cfe0","lang-hi":"31d6cfe0","lang-it":"31d6cfe0","lang-ja":"31d6cfe0","lang-ko":"31d6cfe0","lang-pl":"31d6cfe0","lang-pt":"31d6cfe0","lang-ru":"31d6cfe0","lang-tr":"31d6cfe0","lang-uk":"31d6cfe0","lang-vi":"31d6cfe0","lang-zh-cn":"31d6cfe0","lang-zh-tw":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
